import * as React from "react";
// import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
// import CardContent from '@mui/material/CardContent';
// import CardMedia from '@mui/material/CardMedia';
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";
// import { CardHeader } from "@material-ui/core";

// import { ThemeProvider, createTheme } from "@mui/material/styles";
// import { theme } from "../../theme";

import { image_ip } from "../../services/constants";

import alt_back from "../../zmall.png";

// import background from "../../zmall.png";
// import { textAlign } from "@mui/system";

export default function DeliveryCard(props) {
  var background = props.delivery.image_url
    ? `${image_ip}${props.delivery.image_url}`
    : { alt_back };
  // console.log(background)
  // console.log(props.delivery)
  const nav = useNavigate();
  const data = props.delivery;
  var string = data.description;
  if (string.length > 30) {
    string = string.substring(0, 29) + "...";
  }
  const handleClick = React.useCallback(
    (id) =>
      ({ getItemById, scrollToItem }) => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        nav(`/delivery/${id}`, {
          state: { name: props.delivery.delivery_name },
        });
      },
    [props]
  );
  const container_style = {
    // background: '#EEE',
    margin: "8px",
    // borderRadius: '50%',
    backgroundImage: `url(${background})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    // backgroundSize: 'contain',

    // marginRight: '10px',
  };
  const card_style = {
    borderRadius: "50%",
    display: "flex",
    width: "100px",
    height: "100px",
    justifyContent: "center",

    // textAlign:'-webkit-center'
    alignItems: "end",
    // backgroundImage:  "url('/zmall.png'),"
  };
  const text_style = {
    background: "white",
    textAlign: "center",
    // justifyContent: 'start',
    padding: "4px",
    marginBottom: "5px",
    borderRadius: "10px",
    width: "75%",
    fontSize: "0.6rem",

    // width: '50%'
  };

  return (
    <div style={container_style}>
      <div style={card_style} onClick={handleClick(props.delivery._id)}>
        {/* <img src={background}/> */}
        {/* <Typography gutterBottom variant="subtitle2" component="div" style={text_style}> */}
        <div style={text_style}>{props.delivery.delivery_name}</div>
      </div>

      {/* </Typography> */}
    </div>
  );
  // return (
  //   <Card sx={{ maxWidth: 445}} style={card_style} >
  //     <CardMedia
  //       component="img"
  //       height="140"
  //       // image={`http://196.189.44.49:7000/${props.delivery.image_url}`}
  //       image='zmall.png'
  //       alt="unable to load image"
  //     />
  //     <CardContent>
  //       <Typography gutterBottom variant="subtitle2" component="div">
  //         {props.delivery.delivery_name}
  //       </Typography>
  //       <Typography variant="body2" color="text.secondary">
  //           {string}
  //       </Typography>
  //     </CardContent>
  //     <CardActions>
  //     <ThemeProvider theme={theme}>
  //       <Button  color="neutral" variant="contained" size="small" onClick={handleClick(props.delivery._id)}>See More</Button>
  //       </ThemeProvider>
  //     </CardActions>
  //   </Card>
  // );
}
